import { getInvoiceDisplayNumber } from "./invoiceNumber.utils";

export const parseBalance = (balance) => {
	if (balance == null || balance === "") return 0;
	return Number(String(balance).replace(/[^0-9.-]/g, "") || 0);
};

export const getBalanceDue = (invoice = {}) => {
	if (invoice.balance_due != null && invoice.balance_due !== "") {
		return parseBalance(invoice.balance_due);
	}
	return parseBalance(invoice.Balance);
};

export const formatInvoiceLabel = (invoice = {}) =>
	getInvoiceDisplayNumber({
		invoice_number: invoice.invoice_number,
		id: invoice.id,
	}) || "—";

export const isUndepositedFundsAccount = (account = {}) =>
	account.detail_type === "undeposited_funds" ||
	account.account_type === "undeposited_funds";

export const computeRemainingBalance = (invoices = []) =>
	invoices
		.filter((item) => item.checked)
		.reduce(
			(sum, inv) =>
				sum +
				Math.max(
					0,
					getBalanceDue(inv) - parseFloat(inv.total_payments || 0),
				),
			0,
		);

export const appendPaymentErrorContext = (message, errorOrResponse) => {
	const payload =
		errorOrResponse?.response?.data ??
		errorOrResponse?.data ??
		errorOrResponse;
	const balanceDue = payload?.context?.balance_due;
	if (balanceDue !== undefined && balanceDue !== null) {
		return `${message}\nMax suggested amount: ${balanceDue}`;
	}
	return message;
};

export const formatPaymentReferenceNumber = (referenceNumber) =>
	referenceNumber != null && referenceNumber !== ""
		? String(referenceNumber)
		: "";

export const mergePaymentResponseIntoInvoiceRow = (row = {}, response = {}) => {
	const payload = response?.data ?? response;
	if (!payload?.status) return row;
	const invoice = payload.invoice ?? {};
	const invoiceId = invoice.id ?? row.id;
	if (invoiceId !== row.id) return row;
	const balanceDue =
		payload.balance_due ??
		invoice.balance_due ??
		row.balance_due;
	const paidAmount =
		payload.paid_amount ??
		invoice.paid_amount ??
		row.paid_amount;
	const openBalance = getBalanceDue({ ...row, ...invoice, balance_due: balanceDue });
	return {
		...row,
		...invoice,
		balance_due: balanceDue ?? openBalance,
		Balance: invoice.Balance ?? row.Balance,
		paid_amount: paidAmount,
		total_payments: paidAmount ?? row.total_payments,
		status: invoice.status ?? row.status,
		checked: parseBalance(openBalance) > 0 ? row.checked : false,
	};
};
